var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09693 3.32447C5.41167 2.18766 7.12552 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 10.6021 15.9976 12.0869 15.1419 13.3055L12.75 9H15C15 5.68629 12.3137 3 9 3C7.38736 3 5.92333 3.6362 4.84517 4.67131L4.09693 3.32447ZM13.903 14.6756C12.5883 15.8123 10.8745 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 7.39789 2.00234 5.91312 2.8581 4.69458L5.25 9H3C3 12.3137 5.68629 15 9 15C10.6126 15 12.0767 14.3638 13.1549 13.3287L13.903 14.6756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.f5cf5a1a5a99cf5b97bd82ddc0afe4f6.svg";
export { ForwardRef as ReactComponent };